import { PoStatus } from './usePurchaseOrderService';

export const displayPurchaseOrderState = (state: PoStatus) => {
  switch (state) {
    case PoStatus.Draft:
      return 'Draft';
    case PoStatus.WarehouseProcessing:
      return 'Warehouse Processing';
    case PoStatus.InTransit:
      return 'In Transit';
    case PoStatus.Delivered:
      return 'Delivered';
    case PoStatus.Complete:
      return 'Complete';
  }
};
